import React, { useState, useEffect } from 'react';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
                ? 'py-3 bg-white shadow-lg backdrop-blur-lg border-b border-gray-100'
                : 'py-5 bg-white/80 backdrop-blur-lg'
                }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center">
                    {/* Logo */}
                    <div className="flex items-center">
                        <a href="#" className="flex items-center">
                            <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center text-white font-bold text-xl shadow-md">G</div>
                            <span className="text-2xl font-bold text-secondary ml-1">rovi</span>
                        </a>
                    </div>

                    {/* Desktop navigation - reordered to match app flow */}
                    <div className="hidden md:flex items-center space-x-6">
                        <a href="#caracteristicas" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Características</a>
                        <a href="#planes" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Planes</a>
                        <a href="#como-funciona" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Cómo Funciona</a>
                        <a href="#clientes" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Clientes</a>
                        <a href="#demo" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Demo</a>
                        <a href="#testimonios" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Testimonios</a>
                        <a href="#nosotros" className="px-3 py-2 text-gray-700 hover:text-primary font-medium rounded-lg transition-colors">Nosotros</a>
                        <a href="#contacto" className="ml-2 px-5 py-2.5 rounded-lg bg-primary text-white font-medium hover:bg-primary-dark transition-all duration-300 hover:scale-105 shadow-md">Contacto</a>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="text-gray-700 focus:outline-none hover:bg-gray-100 p-2 rounded-lg transition-colors"
                            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
                        >
                            {isMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"></path>
                                </svg>
                            )}
                        </button>
                    </div>
                </div>

                {/* Mobile menu */}
                {isMenuOpen && (
                    <div className="md:hidden pt-4 pb-3">
                        <div className="flex flex-col space-y-1 bg-white rounded-2xl shadow-xl p-4 mt-4">
                            <a
                                href="#caracteristicas"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Características
                            </a>
                            <a
                                href="#planes"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Planes
                            </a>
                            <a
                                href="#como-funciona"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Cómo Funciona
                            </a>
                            <a
                                href="#clientes"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Clientes
                            </a>
                            <a
                                href="#demo"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Demo
                            </a>
                            <a
                                href="#testimonios"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Testimonios
                            </a>
                            <a
                                href="#nosotros"
                                className="px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Nosotros
                            </a>
                            <a
                                href="#contacto"
                                className="px-4 py-3 mt-2 rounded-lg bg-primary text-white font-medium hover:bg-opacity-90 transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Contacto
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar; 